import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { useCollection } from '@morningtrain/react-resources'

function ColumnFooter ({
  name = null,
  alignment = 'left',
  display = null,
  content = null,
  aggregate = null,
  className = '',
  ...forwardProps
}) {
  const collection = useCollection()

  const defaultAggregator = (acc, entry) => {
    return acc + (entry[name] || 0)
  }

  let value = content

  if (aggregate === 'sum') {
    value = collection.reduce(defaultAggregator, 0)
  }

  if (aggregate === 'avg') {
    value = collection.reduce(defaultAggregator, 0) / collection.length
  }

  if (typeof aggregate === 'function') {
    value = collection.reduce(aggregate, 0)
  }

  let DisplayComponent = display

  if (React.isValidElement(value)) {
    DisplayComponent = value
  } else if (React.isValidElement(DisplayComponent)) {
    DisplayComponent = React.cloneElement(DisplayComponent, { ...forwardProps, name: name, defaultValue: value })
  } else if (DisplayComponent === null) {
    DisplayComponent = value
  } else {
    DisplayComponent = (
      <DisplayComponent {...forwardProps} name={name} defaultValue={value} />
    )
  }

  return (
    <td className={className} align={alignment}>
      {DisplayComponent}
    </td>
  )
}

ColumnFooter.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  alignment: PropTypes.string,
  display: PropTypes.any,
  content: PropTypes.node,
  aggregate: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
}

export default observer(ColumnFooter)
